<template>
  <div class="top-nav">
    <div class="top-nav-log" @click="$router.push('/')">
      <!-- <img src="../../../different/img/logo.png" /> -->
      <img class="logo2" src="@/assets/logo-ctzn.jpg" alt="">
      <div class="logoName">城投助农</div>
    </div>

      <!-- <el-scrollbar tag="div" :native="false" ref="elscrollbar">
        <div v-for="(item, index) in routes" :key="index" class="nav-item">
          <app-link :to="resolvePath(item)">
            <el-menu-item v-if="!item.hidden" :index="item.path">{{
              item.meta ? item.meta.title : item.children[0].meta.title
            }}</el-menu-item>
          </app-link>
        </div>
      </el-scrollbar> -->

      <!-- <div class="center-menu" >
      <div @click="go(item)" v-for="(item,index) in foodMapRoutes" :key="index" class="center-menu-item">{{item.meta.title}}</div>

      </div> -->


    <!-- <el-menu
      :active-text-color="'#ffffff'"
      :default-active="activeMenu"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-scrollbar tag="div" :native="false" ref="elscrollbar">
        <div v-for="(item, index) in routes" :key="index" class="nav-item">
          <app-link :to="resolvePath(item)">
            <el-menu-item v-if="!item.hidden" :index="item.path">{{
              item.meta ? item.meta.title : item.children[0].meta.title
            }}</el-menu-item>
          </app-link>
        </div>
      </el-scrollbar>
    </el-menu> -->
    <div class="right-menu">
      <!-- <el-popover
  placement="bottom"
  width="400"
  trigger="click">
  <div>
    <div>消息提醒（50）</div>
    <div>
      <el-button type="primary" size="mini">全部已读</el-button>
    </div>
  </div>
      <el-badge  slot="reference" :value="12" class="item" :max="99" :hidden="false">
      <img src="@/assets/image/45.png" class="user-message" />
    </el-badge>
  </el-popover> -->
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img src="@/assets/user.png" class="user-avatar" />
          <span class="user_name">{{ $store.state.user.name }}</span>
          <!-- <i class="el-icon-caret-bottom" /> -->
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <!-- <router-link to="/"
            ><el-dropdown-item>我的中心</el-dropdown-item></router-link
          > -->

          <el-dropdown-item divided @click.native="logout"
            ><span style="display: block">退出系统</span></el-dropdown-item
          >
          <el-dropdown-item divided @click.native="isShowChangePsd = true"
            ><span style="display: block">修改密码</span></el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog
      :append-to-body="true"
      title="修改密码"
      :visible.sync="isShowChangePsd"
      center
    >
      <div class="changePsd-box">
        <div class="changePsd-box-item colorRed">
          密码格式：8-20位,密码应至少包含大写字母、小写字母、数字、特殊字符中的三种
        </div>
        <div class="changePsd-box-item">
          <div>原密码：</div>
          <el-input
            show-password
            style="width: 300px"
            maxlength="20"
            placeholder="请输入原密码"
            v-model="oldPsd"
          ></el-input>
        </div>
        <div class="changePsd-box-item">
          <div>新密码：</div>
          <el-input
            show-password
            style="width: 300px"
            placeholder="请输入新密码"
            v-model="newPsd"
          ></el-input>
        </div>
        <div class="changePsd-box-item">
          <div>确认新密码：</div>
          <el-input
            show-password
            style="width: 300px"
            placeholder="请再次输入新密码"
            v-model="confirmNewPsd"
          ></el-input>
        </div>
        <div class="changePsd-box-foot">
          <el-button @click="isShowChangePsd = false">取 消</el-button>
          <el-button type="primary" @click="_changePsd()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { loginTitle } from "../../../different/js/different.js";
import { mapGetters } from "vuex";
import AppLink from "./Sidebar/Link";
import { constantRoutes } from "@/router";
import variables from "@/styles/variables.scss";
import { isExternal } from "@/utils/validate";
import { changePsd } from "@/api/user";
import { sysUserChangeLoginStatus } from "@/api/common";
export default {
  name: "Topbar",
  components: {
    AppLink,
  },
  data() {
    return {
      loginTitle: loginTitle,
      isShowChangePsd: false, //是否展示修改密码弹窗
      oldPsd: "", //旧密码
      newPsd: "", //新密码
      confirmNewPsd: "", //确认新密码
      routes: constantRoutes,
      foodMapRoutes:[],
    };
  },
  created(){
    this.foodMapRoutes= constantRoutes[5].children
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // console.log(meta);
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      // 如果是首页,首页高亮
      if (path === "/dashboard") {
        return "/";
      }
      // 如果不是首页,高亮一级菜单
      const activeMenu = "/" + path.split("/")[1];
      return activeMenu;
    },
    variables() {
      return variables;
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    ...mapGetters(["avatar"]),
  },
  mounted() {
    // this.initCurrentRoutes();
    // 监听el-scrollbar 的里面的 真正的滚动层
    // .el-scrollbar__wrap 是被嵌套在.el-scrollbar 中的
    // document
    //   .querySelector(".el-scrollbar__wrap")
    //   .addEventListener("mousewheel", function (e) {
    //     e.preventDefault();
    //     this.scrollLeft += e.wheelDelta > 0 ? -100 : 100;
    //   });
  },
  methods: {
    go(item){
      this.$router.push({name:item.name})
    },
     resolvePath(item) {
      // 如果是个完成的url直接返回
      // console.log(item)
      if (isExternal(item.path)) {
        return item.path;
      }
      // 如果是首页,就返回重定向路由
      if (item.path === "/") {
        // const path = item.redirect;
        const path = "/";
        return path;
      }

      // 如果有子项,默认跳转第一个子项路由
      let path = "";
      /**
       * item 路由子项
       * parent 路由父项
       */
      const getDefaultPath = (item, parent) => {
        // 如果path是个外部链接（不建议）,直接返回链接,存在个问题：如果是外部链接点击跳转后当前页内容还是上一个路由内容
        if (isExternal(item.path)) {
          path = item.path;
          return;
        }
        // 第一次需要父项路由拼接,所以只是第一个传parent
        if (parent) {
          path += parent.path + "/" + item.path;
        } else {
          path += "/" + item.path;
        }
        // 如果还有子项,继续递归
        if (item.children) {
          getDefaultPath(item.children[0]);
        }
      };

      if (item.children) {
        getDefaultPath(item.children[0], item);
        return path;
      }
      return item.path;
    },
    // // 通过当前路径找到二级菜单对应项,存到store,用来渲染左侧菜单
    // initCurrentRoutes() {
    //   const { path } = this.$route;
    //   let route = this.routes.find(
    //     (item) => item.path === "/" + path.split("/")[1]
    //   );
    //   // 如果找不到这个路由,说明是首页
    //   if (!route) {
    //     route = this.routes.find((item) => item.path === "/");
    //   }
    //   this.$store.commit("permission/SET_CURRENT_ROUTES", route);
    //   this.setSidebarHide(route);
    // },
    // 判断该路由是否只有一个子项或者没有子项,如果是,则在一级菜单添加跳转路由
    // isOnlyOneChild(item) {
    //   if (item.children && item.children.length === 1) {
    //     return true;
    //   }
    //   return false;
    // },
    // resolvePath(item) {
    //   // 如果是个完成的url直接返回
    //   if (isExternal(item.path)) {
    //     return item.path;
    //   }
    //   // 如果是首页,就返回重定向路由
    //   if (item.path === "/") {
    //     // const path = item.redirect;
    //     const path = "/";
    //     return path;
    //   }
    //   // 如果有子项,默认跳转第一个子项路由
    //   let path = "";
    //   /**
    //    * item 路由子项
    //    * parent 路由父项
    //    */
    //   const getDefaultPath = (item, parent) => {
    //     // 如果path是个外部链接（不建议）,直接返回链接,存在个问题：如果是外部链接点击跳转后当前页内容还是上一个路由内容
    //     if (isExternal(item.path)) {
    //       path = item.path;
    //       return;
    //     }
    //     // 第一次需要父项路由拼接,所以只是第一个传parent
    //     if (parent) {
    //       path += parent.path + "/" + item.path;
    //     } else {
    //       path += "/" + item.path;
    //     }
    //     // 如果还有子项,继续递归
    //     if (item.children) {
    //       getDefaultPath(item.children[0]);
    //     }
    //   };
    //   if (item.children) {
    //     getDefaultPath(item.children[0], item);
    //     return path;
    //   }
    //   return item.path;
    // },
    // handleSelect(key, keyPath) {
    //   // 把选中路由的子路由保存store
    //   const route = this.routes.find((item) => item.path === key);
    //   this.$store.commit("permission/SET_CURRENT_ROUTES", route);
    //   this.setSidebarHide(route);
    // },
    // // 设置侧边栏的显示和隐藏
    // setSidebarHide(route) {
    //   if (!route.children || route.children.length === 1) {
    //     this.$store.dispatch("app/toggleSideBarHide", true);
    //   } else {
    //     this.$store.dispatch("app/toggleSideBarHide", false);
    //   }
    // },
    async logout() {
      await sysUserChangeLoginStatus({ loginStatus: 2,id:this.$store.state.user.userId, }).then((res) => {
        console.log(res);
      }); //更改系统用户登录状态
      this.$store.commit("permission/SET_TREE_ROUTES", null);
      await this.$store.dispatch("user/logout");
      // localStorage.clear();
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      location.reload();
    },
    async _changePsd() {
      if (!formatAll("password", this.oldPsd, "旧密码格式不正确,请重新输入!")) {
        //  this.$message({
        //   type: "warning",
        //   message: "旧密码格式不正确,请重新输入!",
        // });
        return;
      }
      if (!formatAll("password", this.newPsd, "新密码格式不正确,请重新输入!")) {
        return;
      }
      if (this.newPsd !== this.confirmNewPsd) {
        this.$message({
          type: "warning",
          message: "两次输入的新密码不一致,请重新输入!",
        });
        return;
      }
      let postData = {
        newPassword: this.confirmNewPsd,
        password: this.oldPsd,
      };
      let state = this.$store.state.user;
      console.log(state);
      let postData2 = {
        newPassword: this.confirmNewPsd,
        oldPassword: this.oldPsd,
        userId: state.userId,
        username: state.name,
      };
      let { data } = await changePsd(postData);
      // let { data2 } = await updateUserLogin(postData2);
      this.$message({
        type: "success",
        message: "修改成功,请重新登录！",
      });
      this.isShowChangePsd = false;
      this.logout();
    },
  },
  // mounted() {
  //   // 默认模拟激活根目录 (临时解决)
  //   this.handleSelect("/", ["/"]);
  //   // 监听el-scrollbar 的里面的 真正的滚动层
  //   // .el-scrollbar__wrap 是被嵌套在.el-scrollbar 中的
  //   document
  //     .querySelector(".el-scrollbar__wrap")
  //     .addEventListener("mousewheel", function (e) {
  //       e.preventDefault();
  //       this.scrollLeft += e.wheelDelta > 0 ? -100 : 100;
  //     });
  // },
};
</script>

<style lang="scss" scoped>
.tags-view-wrapper {
  .tags-view-item {
    display: inline-block;
    position: relative;
    cursor: pointer;
    height: 26px;
    line-height: 26px;
    border: 1px solid #d8dce5;
    color: #495060;
    background: #fff;
    padding: 0 8px;
    font-size: 12px;
    margin-left: 5px;
    margin-top: 4px;
    &:first-of-type {
      margin-left: 15px;
    }
    &:last-of-type {
      margin-right: 15px;
    }
    &.active {
      background-color: #42b983;
      color: #fff;
      border-color: #42b983;
      &::before {
        content: "";
        background: #fff;
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        position: relative;
        margin-right: 2px;
      }
    }
  }
}
.top-nav {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
      // background-color: rgba(70, 76, 91);
      color: #4D5B6E;
      background: #FFFFFF;
box-shadow: 0px 0px 5px 0px rgba(80,85,102,0.15);
height: 64px;
  .top-nav-log {
    cursor: pointer;
    margin-left: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo1{
height: 50px;
  }
  .logo2{
    height: 50px;
    // margin-left: 7px;
  }
  .el-menu {
    margin-right: 15px;
    flex: 1;
    overflow: hidden;
    .el-scrollbar {
      width: 100%;
      white-space: nowrap;
    }
  }
}
.changePsd-box {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  .changePsd-box-item {
    display: flex;
    // width: 70%;
    align-items: center;
    margin-bottom: 20px;
    justify-content: center;
    div {
      width: 100px;
      text-align: right;
    }
  }
  .changePsd-box-foot {
    margin-top: 30px;
    width: 30%;
    display: flex;
    justify-content: space-between;
  }
}
.colorRed {
  color: red;
}
.log{
  img{
padding: 5px;
  }
}
.center-menu{
  // width: 1000px;
  flex-grow: 1 !important;
  flex: 1;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
  .center-menu-item{
width: 100px;
text-align: center;
  }
}
.el-menu{
  background-color: rgba(70, 76, 91, 0.898039215686275);
}
.el-dropdown{
  color: #fff;
}
.right-menu{
  // background-color: rgba(70, 76, 91, 0.898039215686275);
  .user_name{
    color: #4D5B6E;
    font-size: 14px;
  }
  .user-message{
    width: 24px;
    height: 24px;
    // margin-right: 15px;
  }
}
.item {
  margin-top: -10px;
  margin-right: 20px;
}
.logoName{
font-size: 26px;
font-family: AlimamaShuHeiTi-Bold, AlimamaShuHeiTi;
font-weight: bold;
color: #272121;
line-height: 1;
margin-left: 8px;
}
</style>
